import { render } from "./main-search.vue?vue&type=template&id=2bdd81f6"
import script from "./main-search.vue?vue&type=script&lang=js"
export * from "./main-search.vue?vue&type=script&lang=js"

import "./main-search.vue?vue&type=style&index=0&id=2bdd81f6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__